import React from 'react';

export default class TouchBottom extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            touchEnd:false,
            resetTimer:2000,
        }
    }
    //触底高阶组件
    componentDidMount = () => {
        window.addEventListener("scroll",this.handle)
    }

    handle = () => {
        let onPullUpHeight=this.refs.touchBottom && this.refs.touchBottom.clientHeight;
        let documentHeight=document.documentElement && document.documentElement.clientHeight;
        let documentTop=document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset; //兼容性问题
        let minAdd = 100
        if(onPullUpHeight <= documentHeight + documentTop + minAdd){
            this.touchEnd()
        }
    }

    reset = () => {
        // console.log("复位了")
        this.setState({
            touchEnd:false
        })
    }

    touchEnd = () => {
        if(this.state.touchEnd){
            return
        }
        // console.log("到底了")
        this.setState({
            touchEnd:true
        })
        this.timer = setTimeout(this.reset,this.state.resetTimer)
        //touchEnd复位
    }

    componentWillUnmount() {
        clearTimeout(this.timer)
    }

    render() {
        return (
            <div className='touchBottom' ref="touchBottom" style={{height:"100%"}}>
                {
                    React.cloneElement(this.props.children,{touchEnd:this.state.touchEnd})
                }
            </div>
        );
    }
}